import { useDashboardContext } from '../DashboardContext';
import style from './Footer.module.scss';

const Indicator = (props: { isActive: boolean }) => {
    if (props.isActive)
        return (
            <div className="flex gap-2 px-2 items-center text-sf-positive-500">
                <div className={style.indicatorActive}></div>
                Operational
            </div>
        );

    return (
        <div className="flex gap-2 px-2 items-center text-sf-neutral-500">
            <div className={style.indicatorInactive}></div>
            Standby
        </div>
    );
};

export const Footer = () => {
    const { systemVersion, systemState } = useDashboardContext();

    const trimmedSystemVersion = systemVersion?.replace(/-rc$/i, "");;
    
    return (
        <div className="flex h-[56px] px-8 items-center gap-2 font-sf text-12 text-sf-white">
            <div className={style.versions}>
                {trimmedSystemVersion ? <span>{trimmedSystemVersion}</span> : <></>}
                System Status
            </div>
            <Indicator isActive={systemState} />
        </div>
    );
};
